module.exports = __webpack_public_path__ + "assets/d97588129b816bca61ef93e4910c419e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_1.mp3
 ** module id = 330
 ** module chunks = 0
 **/